// The outline drawn behind a label on the takeoff canvas so it reads over the drawing.
//
// The canvas draws its labels inside the pan / zoom group, so a label's font size is in WORLD FEET (about 1 – 1.6 ft when
// zoomed in). A halo width written as a bare number is in the same feet — a "strokeWidth: 4" halo around a 1.5 ft label is a
// 4 ft wide white stroke: the big, ragged white box that hid the drawing around the cursor while tracing a room
// (2026-10-18). The halo is therefore a FRACTION of the label's own size, translucent so the plan still shows through, with
// round joins so the outline of the lettering is smooth rather than spiky.
export const HALO_WIDTH_FRACTION = 0.2;
export const HALO_OPACITY = 0.7;

export function haloStroke(view, fontSize, fallback = "var(--surface)") {
  return {
    paintOrder: "stroke",
    stroke: view?.labelHalo || fallback,
    strokeWidth: Math.max(0, Number(fontSize) || 0) * HALO_WIDTH_FRACTION,
    strokeOpacity: HALO_OPACITY,
    strokeLinejoin: "round",
  };
}
